import { Icon } from '@/components/ui/Icon'
import type { CoplayData } from '@/types'

interface PlayingNudgesProps {
  coplay: CoplayData
  gameTitle: string
  onPromoteToPlayed: () => void
  onDemoteToWishlist: () => void
}

export function PlayingNudges({ coplay, gameTitle, onPromoteToPlayed, onDemoteToWishlist }: PlayingNudgesProps) {
  type Nudge = {
    kind: 'promote' | 'sleeping'
    icon: string
    title: string
    body: string
    primary: { label: string; onClick: () => void }
    secondary?: { label: string; onClick: () => void }
  }

  const nudges: Nudge[] = []

  if (coplay.hasStory && (coplay.progress ?? 0) >= 0.9) {
    nudges.push({
      kind: 'promote',
      icon: 'check',
      title: `Looks like you might be finished ${gameTitle}`,
      body: `${Math.round((coplay.progress ?? 0) * 100)}% through main story by playtime. Move to Played & Rated?`,
      primary: { label: 'Mark played', onClick: onPromoteToPlayed },
    })
  } else if (coplay.daysSinceLast != null && coplay.daysSinceLast >= 5) {
    nudges.push({
      kind: 'sleeping',
      icon: 'eye-off',
      title: `${gameTitle} has been quiet for ${coplay.daysSinceLast} days`,
      body: 'No group co-play detected lately. Plan a session — or move it off Now Playing?',
      primary: { label: 'Mark played', onClick: onPromoteToPlayed },
      secondary: { label: 'Back to wishlist', onClick: onDemoteToWishlist },
    })
  }

  if (nudges.length === 0) return null

  return (
    <div className="cg-pt-nudges">
      {nudges.map((n, i) => (
        <div key={i} className={`cg-pt-nudge cg-pt-nudge-${n.kind}`}>
          <div className="cg-pt-nudge-icon">
            <Icon name={n.icon} size={12} />
          </div>
          <div className="cg-pt-nudge-body">
            <div className="cg-pt-nudge-title">{n.title}</div>
            <div className="cg-pt-nudge-desc">{n.body}</div>
          </div>
          <div className="cg-pt-nudge-actions">
            <button
              className="cg-btn cg-btn-primary"
              data-action="played"
              style={{ fontSize: 11, padding: '4px 10px' }}
              onClick={n.primary.onClick}
            >
              <Icon name="star" size={10} />
              {n.primary.label}
            </button>
            {n.secondary && (
              <button
                className="cg-btn"
                data-action="wishlist"
                style={{ fontSize: 11, padding: '4px 10px' }}
                onClick={n.secondary.onClick}
              >
                <Icon name="wishlist" size={10} />
                {n.secondary.label}
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
